import { render } from "./student-card.vue?vue&type=template&id=2d7dc266&scoped=true&ts=true"
import script from "./student-card.ts?vue&type=script&lang=ts&external"
export * from "./student-card.ts?vue&type=script&lang=ts&external"

import "./student-card.scss?vue&type=style&index=0&id=2d7dc266&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7dc266"]])

export default __exports__